export default __webpack_public_path__ + "static/media/iPermit_roof_gray.252b2355.svg";